exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-classification .classification-comment{margin-top:.75rem}.fts-classification .teammate-form-actions{display:flex;flex-wrap:wrap;gap:.375rem;margin:.25rem 0 .5rem}", ""]);

// exports
